var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"row row-left"},[_c('h4',{staticClass:"title__medium"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._t("back")],2),_c('i',{staticClass:"material-icons close",on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s('close'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }